var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { usePageEntity } from '../hooks/use-page-entity';
import { SliceSidebarSectionLayout } from './slice-sidebar-section-layout';
import { EntityMetaSection } from './entity-meta-section';
var cls = classNames('slice-moderators');
export var SliceModeratorsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n  "])), theme.COLOR('canvas'))
});
var ModeratorsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  NAME: 'SliceModerators',
  Container: styled(SliceSidebarSectionLayout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Moderators: styled(EntityMetaSection)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ModeratorsStyles)
};
export var SliceModerators = function (props) {
  var _a = useComponentProps(My.NAME, SliceModeratorsDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    variant = _a.variant;
  var activeEntity = usePageEntity();
  var newEntity = __assign(__assign({}, entity), {
    moderators: activeEntity.moderators
  });
  return React.createElement(My.Container, {
    className: cls.name(className),
    entity: newEntity
  }, newEntity.moderators && React.createElement(My.Moderators, {
    items: newEntity.moderators
  }));
};
SliceModerators.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;